import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nProvider";

export default function Marquee() {
  const { t } = useI18n();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <section aria-hidden className="relative py-12 md:py-20 overflow-hidden border-y border-slate-200 bg-slate-50">
      <div className="marquee-track font-display font-medium text-slate-900/[0.09] text-[15vw] md:text-[10vw] leading-none tracking-tight whitespace-nowrap select-none">
        {items.map((it, i) => (
          <span key={i} className="flex items-center gap-16">
            {it}
            <span className="w-3 h-3 rounded-full bg-[var(--steel)]" />
          </span>
        ))}
      </div>
    </section>
  );
}
